export const getTranslatedStatus = (prefix: string, key: string | boolean) =>
  `${prefix}.${key.toString().toUpperCase()}`;
